module.exports = __webpack_public_path__ + "img/lawOffice-1.3efdc04f.png";